import { IReward } from './IReward';
import { Reward } from './Reward';

export class TunesGrantReward extends Reward {
	public static readonly CLASS: string = 'com.bancvue.rcx.config.product.rewards.api.TunesGrantReward';

	public static readonly NAME: string = 'Tunes Grant';

	amount: number = 0;

	duration: number = 0;

	constructor(reward?: IReward) {
	  super(TunesGrantReward.CLASS, reward ? reward.id : null);

	  if (reward) {
	    this.amount = (reward as any).amount;
	    this.duration = (reward as any).duration;
	  }
	}

	getDescription(): string {
	  return `$${this.amount} Tunes Cycle Grant Reward valid for ${this.duration} days.`;
	}

	clone(): IReward {
	  const clone = new TunesGrantReward();
	  Object.assign(clone, this);
	  return clone;
	}
}

export default TunesGrantReward;
